<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月15日 15:08:49 +0800
 * @最后修改时间: 2021-11-17 17:11:03
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterTemplate\components\editRosterTemplateDialog.vue
 -->
 <template>
  <normalDialog
    width="680"
    maxWidth="680"
    @close="closePorpertyDialog"
    :title="
      $t('label_essweb_RosterTemplate_form_dialog_editShiftTemplateMapping')
    "
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row dense>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_RosterTemplate_form_dialog_shiftNameLabel"
              :items="AllShift"
              item-text="shift_name"
              item-value="uuid"
              deletable-chips
              two-line
              v-model="shift_uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              filled
            >
              <template v-slot:item.subtitle="{ data }">
                {{ $timeMachine(data.item.start_utc_time) }}-{{
                  $timeMachine(data.item.end_utc_time)
                }}
              </template>
            </AutoComplete>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="toSave" @cancel="closePorpertyDialog" />
    </template>
  </normalDialog>
</template>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editRosterTemplateDialog",
  props: ["show", "curProperty"],
  computed: {
    ...mapGetters(["companyLang"]),
    AllShift() {
      return this.$getSelectTrans(this.AllShiftData, "shift_name");
    },
  },
  data() {
    return {
      shift_uuid: "",
      AllShiftData: [],
      MappingData: {
        uuid: null,
        sequence: "",
        shift: null,
        remarks: "",
      },
    };
  },
  watch: {
    show(val) {
      if (!val) {
        //  if (this.$refs["form"]) this.$refs["form"].reset();
      }
    },
    shift_uuid(val) {
      this.MappingData.shift = this.AllShiftData.filter(
        (ele) => ele.uuid === val
      )[0];
    },
    curProperty(val) {
      if (val) {
        // console.log(val);
        if (val.shift) {
          this.shift_uuid = val.shift.uuid;
        } else {
          this.shift_uuid = "";
        }
        this.MappingData.uuid = val.uuid;
        this.MappingData.sequence = val.sequence;
        this.MappingData.shift = val.shift;
        this.MappingData.remarks = val.remarks;
      }
    },
  },
  mounted() {
    const that = this;
    this.$Request({
      method: "POST",
      table: "ess_att_shift",
      url: "/shift/get-shift-list/",
    }).then((res) => {
      that.AllShiftData = res.data;
    });
  },

  methods: {
    closePorpertyDialog: function () {
      this.$emit("close");
    },
    toSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onEdit", this.MappingData);
    },
  },
};
</script>
